import { ThemedText, ThemedView } from "@app/theme"
import EndJourneyIcon from "./EndJourneyIcon"
import Button from "@app/sharedComponents/Button/Button";
import InfoIcon from "@app/assets/svg/infoIcon";
import ROUTE from "@app/navigationApp/routes";

export const EndJourney = ({
    navigation,
    route
}) => {
    const handleContinue = () => {
        navigation.reset({
            index: 0,
            routes: [{ name: ROUTE.KYC_STEPPER }],
        });
    }
    return (
        <ThemedView backgroundColor="bg-surface-primary" flex={1} padding='xl' justifyContent='center' alignItems='center' >
            <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="md" >
                <ThemedView padding='md' >
                    <EndJourneyIcon />
                    <ThemedView marginBottom='md' /> 
                    <ThemedText
                        variant="h5s"
                        color="text-primary"
                        marginBottom="lg"
                    >
                        Do you want to continue your loan application journey?
                    </ThemedText>
                    <Button
                        eventName={route.name + '_GET_MY_PORTFOLIO'}
                        label={'Continue loan application'}
                        handlePress={() => {
                            handleContinue()
                        }}
                        type={'OUTLINED'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        buttonLoader={false}
                    />
                </ThemedView>
                <ThemedView backgroundColor='bg-fill-emphasis-primary-1' flexDirection='row' alignItems='center' gap='sm' padding='md' borderBottomLeftRadius="md" borderBottomRightRadius="md" >
                    <InfoIcon/>
                    <ThemedText variant="b4r" color="text-secondary">
                        Close the tab if selfie verification is the only step you wanted to complete
                    </ThemedText>
                </ThemedView>
            </ThemedView>

        </ThemedView>
    )
}       